/**
 * requiredParams => 必传参数，如果url没有携带requiredParams的参数则无法初始化页面
 * optionalParams => 可选参数
 */

module.exports = {
  index: {
    title: '',
    requiredParams: {},
    optionalParams: {}
  },
  'area-list': {
    title: '',
    requiredParams: {},
    optionalParams: {}
  },
  download: {
    title: '',
    requiredParams: {},
    optionalParams: {
      articleId: '文章id'
    }
  },
  activity: {
    title: '',
    requiredParams: {},
    optionalParams: {}
  },
  'event-terms': {
    title: '', // 活动条款
    requiredParams: {},
    optionalParams: {}
  },
  'open-account': {
    title: '',
    requiredParams: {},
    optionalParams: {}
  },
  'set-pwd': {
    title: '',
    requiredParams: {},
    optionalParams: {}
  },
  'wx-auth': {
    title: '',
    requiredParams: {},
    optionalParams: {}
  },
  'wx-bind-res': {
    title: '',
    requiredParams: {},
    optionalParams: {}
  },

  'activity-tradego': {
    title: '', // 捷利交易宝活动
    requiredParams: {},
    optionalParams: {}
  },
  'event-terms-tradego': {
    title: '', // 捷利交易宝活动条款
    requiredParams: {},
    optionalParams: {}
  },

  'activity-multiple': {
    title: '', // 多团开活动
    requiredParams: {
      sign: '活动标志'
    },
    optionalParams: {}
  },
  'event-terms-multiple': {
    title: '', // 多团开活动条款
    requiredParams: {
      sign: '活动标志'
    },
    optionalParams: {}
  },

  'event-terms-common': {
    title: '', // 通用活动条款
    requiredParams: {
      id: '活动id'
    },
    optionalParams: {}
  },

  'activity-seed-user': {
    title: '', // 种子用户互动
    requiredParams: {},
    optionalParams: {}
  },
  'activity-new-user': {
    title: '', // 迎新推广活动
    requiredParams: {},
    optionalParams: {}
  },
  'activity-essence-reward': {
    title: '', // 精华奖励
    requiredParams: {},
    optionalParams: {}
  },
  'activity-invite-friend': {
    title: '', // 邀请好友活动
    requiredParams: {},
    optionalParams: {}
  },
  'activity-invite-friend2': {
    title: '', // 邀请好友活动2
    requiredParams: {},
    optionalParams: {}
  },
  'activity-new-user2': {
    title: '', // 7月迎新活动
    requiredParams: {},
    optionalParams: {}
  },
  'activity-new-user2-cn': {
    title: '', // 迎新活动【内地版本】
    requiredParams: {},
    optionalParams: {}
  },
  'activity-new-user3': {
    title: '', // 迎新活动3
    requiredParams: {},
    optionalParams: {}
  },
  'activity-us-trade': {
    title: '', // 美股交易活动
    requiredParams: {},
    optionalParams: {}
  },
  'activity-stock-trans': {
    title: '', // 股票转仓活动
    requiredParams: {},
    optionalParams: {}
  },
  'activity-new-user4': {
    title: '', // 迎新活动4（24年4月）
    requiredParams: {},
    optionalParams: {}
  },
  'activity-new-user5': {
    title: '', // 迎新活动5（24年6月）
    requiredParams: {},
    optionalParams: {}
  },
  'activity-new-user6': {
    title: '', // 迎新活动6（24年7月）
    requiredParams: {},
    optionalParams: {}
  },
  'activity-new-user7': {
    title: '', // 迎新活动7（24年10月）
    requiredParams: {},
    optionalParams: {}
  },
  'activity-new-user8': {
    title: '', // 迎新活动7（25年02月）
    requiredParams: {},
    optionalParams: {}
  },
  'activity-trade-star': {
    title: '', // 港美股交易之星（24年5月）
    requiredParams: {},
    optionalParams: {}
  },
  'activity-trade-expert': {
    title: '', // 交易达人（23年10月）
    requiredParams: {},
    optionalParams: {}
  },
  'invite-friend': {
    title: '',
    requiredParams: {},
    optionalParams: {}
  },
  'invite-detail': {
    title: '',
    requiredParams: {},
    optionalParams: {}
  },
}

